/* TRU product page design (Oct 2026): small layout helpers for the buy box. */
(function () {
  function openChat(e) {
    if (e) e.preventDefault();
    if (window.GorgiasChat && window.GorgiasChat.open) window.GorgiasChat.open();
  }

  function init() {
    var info = document.querySelector('.product__info-container');
    if (!info || info.getAttribute('data-tru-pa')) return;
    info.setAttribute('data-tru-pa', '1');

    /* Availability line: first visible line is the status (green dot, amber when it says call/chat),
       the rest are small notes. Life-cycle notices (Final Sale...) keep their own style. */
    var ship = info.querySelector('.tru-ship');
    function classifyShip() {
      if (!ship) return;
      var gotStatus = false;
      Array.prototype.forEach.call(ship.children, function (s) {
        if (s.tagName !== 'SPAN') return;
        s.classList.remove('tru-ship__st', 'tru-ship__note', 'is-warn');
        if (s.classList.contains('tru-ship__life') || s.hidden) return;
        if (!gotStatus) {
          s.classList.add('tru-ship__st');
          gotStatus = true;
          if (/call|chat|back.?order|special order|out of stock|contact|discontinued|unavailable/i.test(s.textContent)) s.classList.add('is-warn');
        } else {
          s.classList.add('tru-ship__note');
        }
      });
    }
    classifyShip();

    /* Quantity + Add to Cart on one row; availability line directly above it (after any add-ons). */
    var atc = info.querySelector('button[name="add"]');
    var btns = atc && atc.closest('.product-form__buttons');
    var qty = info.querySelector('.product-form__quantity');
    if (btns) {
      btns.classList.add('tru-buyrow');
      if (qty) btns.insertBefore(qty, btns.firstChild);
      var placeShip = function () {
        var m = btns.parentNode.querySelector('.tru-nocombo-msg');
        var anchor = m || btns;
        if (ship && anchor.previousElementSibling !== ship) btns.parentNode.insertBefore(ship, anchor);
      };
      placeShip();
      /* The add-ons app renders after load; keep the availability line below it. */
      var mo = new MutationObserver(placeShip);
      mo.observe(btns.parentNode, { childList: true });
      setTimeout(function () { mo.disconnect(); }, 15000);
    }

    /* Option values that don't exist with what's picked in the other options are crossed out
       (still clickable). Values that exist but can't be sold get a dashed outline. Products that keep
       selling when out of stock are never marked, because Shopify reports those variants as available. */
    var vr = info.querySelector('variant-radios, variant-selects');
    var vjson = vr && vr.querySelector('script[type="application/json"]');
    var variants = [];
    try { variants = vjson ? JSON.parse(vjson.textContent) : []; } catch (e) {}
    function optionGroups() {
      if (!vr) return [];
      var fs = Array.prototype.slice.call(vr.querySelectorAll('fieldset'));
      if (fs.length) return fs.map(function (f) { return { el: f, radios: true }; });
      return Array.prototype.slice.call(vr.querySelectorAll('select')).map(function (s) { return { el: s, radios: false }; });
    }
    function picked(groups) {
      return groups.map(function (g) {
        if (!g.radios) return g.el.value;
        var c = g.el.querySelector('input:checked'); return c ? c.value : null;
      });
    }
    function markOptions() {
      if (!vr || !variants.length) return;
      var groups = optionGroups();
      var sel = picked(groups);
      groups.forEach(function (g, i) {
        var items = g.radios ? g.el.querySelectorAll('input[type="radio"]') : g.el.querySelectorAll('option');
        Array.prototype.forEach.call(items, function (inp) {
          var match = variants.filter(function (v) {
            return v.options[i] === inp.value && v.options.every(function (o, j) { return j === i || o === sel[j]; });
          });
          var na = match.length === 0;
          var oos = !na && !match.some(function (v) { return v.available; });
          if (g.radios) {
            var lab = g.el.querySelector('label[for="' + inp.id + '"]') || inp.nextElementSibling;
            if (!lab) return;
            lab.classList.toggle('is-na', na);
            lab.classList.toggle('is-oos', oos);
            if (na) lab.setAttribute('title', 'Not available with the other options you picked'); else lab.removeAttribute('title');
          } else {
            if (!inp.hasAttribute('data-tru-label')) inp.setAttribute('data-tru-label', inp.textContent);
            inp.textContent = inp.getAttribute('data-tru-label') + (na ? ' (not available)' : '');
          }
        });
      });
      /* No variant for the full selection: Shopify disables Add to Cart but leaves the last real
         variant's stock line, Final Sale, notes and part number on the page. Hide those and say why. */
      var none = !variants.some(function (v) { return v.options.every(function (o, j) { return o === sel[j]; }); });
      document.documentElement.classList.toggle('tru-nocombo', none);
      var msg = info.querySelector('.tru-nocombo-msg');
      if (none && !msg && btns) {
        msg = document.createElement('p');
        msg.className = 'tru-nocombo-msg';
        msg.setAttribute('role', 'status');
        msg.textContent = 'Not available in this combination. Choose a different option above.';
        btns.parentNode.insertBefore(msg, btns);
      }
    }
    markOptions();

    /* Pinned price + Add to Cart once the buy box's button scrolls off the top: in the section bar on
       desktop, in a bar along the bottom of the screen on phones. Both scroll back to the buy box so the
       shopper sees options, fit check and add-ons before adding. Hidden when the button is disabled. */
    function curPrice() {
      var p = info.querySelector('.price--on-sale .price-item--sale') || info.querySelector('.price .price-item--regular');
      return p ? p.textContent.trim() : '';
    }
    function toBuyBox() { atc.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    var pins = [];
    if (atc && 'IntersectionObserver' in window) {
      var jump = document.querySelector('.tru-jump');
      if (jump && !jump.querySelector('.tru-jumpbuy')) {
        var jb = document.createElement('div');
        jb.className = 'tru-jumpbuy';
        jb.innerHTML = '<span class="tru-jumpbuy__p"></span><button type="button" class="tru-jumpbuy__b">Add to cart</button>';
        jb.querySelector('button').addEventListener('click', toBuyBox);
        jump.appendChild(jb);
        pins.push({ el: jb, price: jb.querySelector('.tru-jumpbuy__p') });
      }
      if (!document.querySelector('.tru-mbar')) {
        var mb = document.createElement('div');
        mb.className = 'tru-mbar';
        mb.innerHTML = '<span class="tru-mbar__p"></span><button type="button" class="tru-mbar__b">Add to cart</button>';
        mb.querySelector('button').addEventListener('click', toBuyBox);
        document.body.appendChild(mb);
        document.documentElement.classList.add('tru-has-mbar');
        pins.push({ el: mb, price: mb.querySelector('.tru-mbar__p'), mobile: true });
      }
      var past = false;
      var atcNow = function () { return info.querySelector('button[name="add"]') || atc; };
      var syncPins = function () {
        var price = curPrice();
        var on = past && !atcNow().disabled && !!price;
        pins.forEach(function (pn) {
          pn.price.textContent = price;
          pn.el.classList.toggle('is-on', on);
          if (pn.mobile) document.documentElement.classList.toggle('tru-mbar-on', on);
        });
      };
      var checkPast = function () {
        var nowPast = atcNow().getBoundingClientRect().bottom < 0;
        if (nowPast !== past) { past = nowPast; syncPins(); }
      };
      new IntersectionObserver(checkPast).observe(atc);
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { ticking = false; checkPast(); });
      }, { passive: true });
      var pw = info.querySelector('[id^="price-"]');
      if (pw) new MutationObserver(syncPins).observe(pw, { childList: true, subtree: true, characterData: true });
      new MutationObserver(syncPins).observe(atc, { attributes: true, attributeFilter: ['disabled'] });
      syncPins();
    }

    /* Section bar: add Overview (the product description) when it's on the page. */
    var jumpUl = document.querySelector('.tru-jump ul');
    if (jumpUl && document.getElementById('tru-overview') && !jumpUl.querySelector('a[href="#tru-overview"]')) {
      var ovLi = document.createElement('li');
      ovLi.innerHTML = '<a href="#tru-overview">Overview</a>';
      jumpUl.appendChild(ovLi);
    }

    /* Phones: long detail blocks (overview, features, fitment, specs, what's in the box) start
       collapsed with a "Show all" button so the page isn't one very long scroll. */
    function clampDetails() {
      if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return;
      ['tru-overview', 'tru-features', 'tru-fitment', 'tru-specs', 'tru-box'].forEach(function (id) {
        var s = document.getElementById(id);
        if (!s || s.hasAttribute('data-tru-clamp') || s.scrollHeight < 560) return;
        s.setAttribute('data-tru-clamp', 'closed');
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'tru-more';
        b.textContent = 'Show all';
        b.setAttribute('aria-expanded', 'false');
        b.setAttribute('aria-controls', id);
        b.addEventListener('click', function () {
          var open = s.getAttribute('data-tru-clamp') === 'open';
          s.setAttribute('data-tru-clamp', open ? 'closed' : 'open');
          b.textContent = open ? 'Show all' : 'Show less';
          b.setAttribute('aria-expanded', open ? 'false' : 'true');
          if (open) s.scrollIntoView({ block: 'start' });
        });
        s.appendChild(b);
      });
    }
    clampDetails();

    /* Re-run the variant-aware bits when the selection changes. */
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('variant-radios, variant-selects')) {
        markOptions();
        setTimeout(function () { markOptions(); classifyShip(); }, 80);
        setTimeout(classifyShip, 450);
      }
    });
  }

  /* Live chat links ([data-tru-chat]) and "See important notes" in the fitment card. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-tru-chat]')) { openChat(e); return; }
    if (e.target.closest('.cm_verify-fitment_exclusion-notice')) {
      var n = document.getElementById('tru-notes');
      if (n) n.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
